import { CardMedia, styled } from "@mui/material";

interface StyledCardMediaProps {
  size?: "small" | "medium" | "large";
}

export const StyledCardMedia = styled(CardMedia)<StyledCardMediaProps>`
  border-radius: ${(props) => props.theme.wsc.radius.m};
  background-color: ${(props) => props.theme.wsc.palette.neutral[500]};

  ${(props) =>
    props.size === "small" &&
    `
        width: 5.1428rem;
        height: 3.4285rem;
    `}

  ${(props) =>
    props.size === "medium" &&
    `
        width: 8.8571rem;
        height: 5.7142rem;
    `}

    ${(props) =>
    props.size === "large" &&
    `
        width: 15.4285rem;
        height: 10rem;
    `}
`;
